import { Injectable, TransferState, makeStateKey } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  constructor(private state: TransferState) {}

  get(key: string) {
    return this.state.get(makeStateKey(key), null);
  }

  set(key: string, data: any) {
    return this.state.set(makeStateKey(key), data);
  }

  remove(key: string) {
    return this.state.remove(makeStateKey(key));
  }
}
